module.exports = __webpack_public_path__ + "media/images/logo-b96a1b94e2f45c4d0b744b88a11875fc.png";